import { makeStyles } from '@material-ui/core/styles';
import { essityBrand } from './colours';

const LEGACY_PLUGIN_HEADER = [
  '[class*="bui-PluginHeader"]:has(+ [data-backstage-core-header])',
  '[class*="bui-PluginHeader"]:has(+ [data-backstage-core-page] [data-backstage-core-header])',
].join(', ');

// Backstage UI (new frontend system) page headers get the same title style and pink rule as BackstageHeader.
// BUI class names are hashed, so match on the stable `bui-` prefix.
const useStyles = makeStyles(
  theme => {
    const titleColour =
      theme.palette.type === 'light'
        ? theme.palette.primary.main
        : theme.palette.text.primary;
    return {
      '@global': {
        // Legacy Page/Header pages (e.g. Explore) switch the plugin header to a white bar without divider;
        // keep it the same as on Backstage UI pages such as Catalog.
        [LEGACY_PLUGIN_HEADER]: {
          '--bui-plugin-header-background-color': 'transparent',
          '--bui-plugin-header-toolbar-border-bottom':
            'solid 1px var(--bui-border-1)',
          '--bui-plugin-header-toolbar-padding-bottom': 'var(--bui-space-4)',
          '--bui-plugin-header-padding-top': 'var(--bui-space-4)',
          '--bui-plugin-header-margin-bottom': '0',
          '& [class*="bui-PluginHeaderToolbarIcon"]': {
            backgroundColor: 'var(--bui-bg-neutral-1)',
          },
        },
        '[class*="bui-HeaderContent"] [class*="bui-HeaderTitle"]': {
          color: titleColour,
          fontFamily: theme.typography.fontFamily,
          fontSize: theme.typography.h3.fontSize,
          fontWeight: theme.typography.h1.fontWeight,
          lineHeight: 1.2,
        },
        '[class*="bui-HeaderBottom"]': {
          paddingBottom: theme.spacing(2),
          borderBottom: `6px solid ${essityBrand.pink}`,
        },
        '[class*="bui-HeaderBottom"] [class*="bui-HeaderDescription"]': {
          color: titleColour,
        },
      },
    };
  },
  { name: 'EssityGlobalStyles' },
);

export const EssityGlobalStyles = () => {
  useStyles();
  return null;
};
